<template lang="">
  <Teleport to="body">
    <div :id="idModal" class="modal fade" tabindex="-1">
      <div
        class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-body">
            <h1 class="modal-title fs-5 text-primary mb-3">
              <span v-if="errors.length > 0">Ups, lo lamento</span>
            </h1>

            <ul v-if="errors.length > 0">
              <li
                v-for="(error, index) in errors"
                :key="index"
                class="text-danger"
              >
                {{ error.detail }}
              </li>
            </ul>

            <div v-if="info" class="row">
              <div class="col-12">
                <div
                  v-if="customerLimitWarning"
                  class="alert alert-warning d-flex gap-2 align-items-start mb-3"
                  role="alert"
                >
                  <i class="mdi mdi-alert-circle-outline fs-5 lh-1" aria-hidden="true"></i>
                  <span>{{ customerLimitWarning }}</span>
                </div>
              </div>
              <div class="col-12 col-xl-6">
                <h2 class="modal-title fs-4 text-success mb-3">
                  {{ getTitle("cart", "product_was_added_to_cart") }}
                </h2>
                <div
                  v-for="(detailProduct, index) in info"
                  :key="index"
                  class="d-flex flex-row border-bottom border-light-subtle py-2 last-no-border"
                >
                  <image-product
                    v-if="detailProduct.product.medium_cover_url"
                    :image="detailProduct.product.medium_cover_url"
                    :max-height="150"
                  />
                  <div class="col-8 p-2">
                    <div>
                      <span class="fs-5 text-secondary">{{
                        detailProduct.product.name
                      }}</span>
                    </div>
                    <div
                      v-if="detailProduct.product.is_kit"
                      class="d-flex align-items-center"
                    >
                      <div
                        class="text-secondary m-0 text-decoration-line-through"
                        v-html="detailProduct.product.set_base_price_with_tax"
                      />
                      <span class="badge badge-pill badge-light">
                        {{ getTitle("cart", "price_with_kit") }}
                      </span>
                    </div>
                    <div v-if="detailProduct.product.promotion_id" class="my-2">
                      <div
                        class="text-secondary text-decoration-line-through m-0"
                        v-html="detailProduct.product.common_price_with_tax"
                      />
                      <div
                        class="d-flex align-items-start align-items-lg-center flex-column flex-lg-row"
                      >
                        <div class="d-flex align-items-end">
                          <h3
                            class="mb-0 text-primary"
                            v-html="
                              detailProduct.product.promotion_price_with_tax
                            "
                          />
                          <span class="text-secondary"
                            >/{{ getTitle("cart", "pieces") }}</span
                          >
                        </div>
                        <span
                          v-if="detailProduct.product.discount_rate >= 0.1"
                          class="text-blue ms-2"
                        >
                          {{ detailProduct.product.discount_rate }}%
                          {{ getTitle("cart", "off") }}
                        </span>
                      </div>
                      <small class="text-danger mt-1">
                        {{ getTitle("cart", "iva_incluido") }}
                      </small>
                    </div>
                    <div v-else>
                      <div class="d-flex align-items-end">
                        <h3
                          class="mb-0"
                          v-html="detailProduct.product.common_price_with_tax"
                        />
                        <span class="text-secondary"
                          >/ {{ getTitle("cart", "unit_name") }}</span
                        >
                      </div>
                      <small class="text-danger mt-1">
                        {{ getTitle("cart", "iva_incluido") }}
                      </small>
                    </div>
                    <table
                      class="table mt-2 mb-0 text-secondary table-sm table-fixed small w-auto"
                    >
                      <tbody>
                        <tr>
                          <th colspan="3" class="pt-0">
                            <span class="text-secondary">
                              {{
                                detailProduct.product.promotion_quantity +
                                detailProduct.product.common_quantity
                              }}
                              {{ detailProduct.product.unit_name }}
                            </span>
                          </th>
                        </tr>
                        <tr
                          v-if="
                            detailProduct.product.promotion_quantity > 0 &&
                            detailProduct.product.common_quantity > 0
                          "
                        >
                          <th class="text-right">
                            <span
                              class="text-secondary"
                              v-text="detailProduct.product.promotion_quantity"
                            />
                            <small v-text="' x '" />
                          </th>
                          <td class="text-right">
                            <div
                              class="text-success"
                              v-html="
                                detailProduct.product.promotion_price_with_tax
                              "
                            />
                          </td>
                          <td
                            v-if="detailProduct.product.common_quantity > 0"
                            width="1"
                          >
                            <!-- <a
                              href="#"
                              class="text-info"
                              data-toggle="tooltip"
                              :title="
                                getTitleOptions('cart', 'promotion_limited', {
                                  ':count': count_promotion_limited,
                                })
                              "
                              @click.prevent
                              v-text="'*'"
                            /> -->
                          </td>
                        </tr>
                        <tr
                          v-if="
                            detailProduct.product.common_quantity > 0 &&
                            detailProduct.product.promotion_quantity > 0
                          "
                        >
                          <th>
                            <span
                              class="text-secondary"
                              v-text="detailProduct.product.common_quantity"
                            />
                            <small v-text="' x '" />
                          </th>
                          <td class="text-right">
                            <div
                              class="text-secondary"
                              v-html="
                                detailProduct.product.common_price_with_tax
                              "
                            />
                          </td>
                          <td width="1" />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-xl-6 border-start border-light-subtle px-4 d-flex flex-column justify-content-start"
              >
                <h2 class="modal-title fs-4 text-primary mb-3">
                  {{ getTitle("cart", "cart_summary") }}
                </h2>
                <div>
                  <div
                    class="row justify-content-end border-bottom border-light-subtle p-2"
                  >
                    {{ cart?.count }}
                    {{
                      cart?.count > 1
                        ? getTitle("cart", "products")
                        : getTitle("cart", "product")
                    }}
                  </div>
                  <div class="row border-bottom border-light-subtle p-2">
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "subtotal") }}
                    </h5>
                    <div
                      class="col-6 text-end"
                      v-html="formatPrice(cart?.subtotal)"
                    />
                  </div>
                  <div
                    v-if="cart?.total_discount != null"
                    class="row border-bottom border-light-subtle p-2"
                  >
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "discount") }}
                    </h5>
                    <div
                      class="col-6 text-end"
                      v-html="formatPrice(cart?.total_discount)"
                    />
                  </div>
                  <div
                    v-if="
                      cart?.has_shipping == true ||
                      cart?.pickup_store_id != null
                    "
                    class="row border-bottom border-light-subtle p-2"
                  >
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "shipment") }}
                    </h5>
                    <small
                      v-if="cart?.pickup_store_id"
                      class="col-6 text-end text-secondary"
                    >
                      {{ getTitle("cart", "store_pickup") }}
                    </small>
                    <strong
                      v-else-if="cart?.shipping == null || cart?.shipping == 0"
                      class="col-6 text-end text-success"
                    >
                      {{ getTitle("cart", "free") }}
                    </strong>
                    <div
                      v-else
                      class="col-6 text-end"
                      v-html="formatPrice(cart?.shipping)"
                    />
                  </div>
                  <div
                    v-if="
                      cart?.has_shipping == true && cart?.shipping_insurance > 0
                    "
                    class="row border-bottom border-light-subtle p-2"
                  >
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "package_insurance") }}
                    </h5>
                    <div
                      class="col-6 text-end text-secondary"
                      v-html="formatPrice(cart?.shipping_insurance)"
                    />
                  </div>
                  <div
                    v-if="cart?.has_coupon"
                    class="row border-bottom border-light-subtle p-2"
                  >
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "apply_coupon") }}
                    </h5>
                    <div
                      class="col-6 text-end text-secondary"
                      v-html="formatPrice(cart?.coupon_discount)"
                    />
                  </div>
                  <div class="row border-bottom border-light-subtle p-2">
                    <h5 class="col-6 my-0">
                      {{ getTitle("cart", "iva") }}
                      (16 %)
                    </h5>
                    <div
                      class="col-6 text-end text-secondary"
                      v-html="formatPrice(cart?.tax)"
                    />
                  </div>
                  <div class="row border-bottom border-light-subtle p-2">
                    <h4 class="col-6 my-0">
                      {{ getTitle("cart", "total") }}
                    </h4>
                    <div
                      class="col-6 text-end text-secondary"
                      v-html="formatPrice(cart?.total)"
                    />
                  </div>
                </div>
                <div
                  class="btn-group mt-4 w-100"
                  role="group"
                  aria-label="Basic example"
                >
                  <a
                    href="#"
                    class="col-4 btn btn-danger align-self-stretch d-flex align-items-center justify-content-center"
                    @click.prevent="goToCheckout"
                  >
                    {{ getTitle("cart", "go_pay") }}
                  </a>
                  <a
                    href="#"
                    class="col-4 btn btn-info align-self-stretch d-flex align-items-center justify-content-center text-white"
                    @click.prevent="goTo({ name: 'cart-detail' })"
                  >
                    {{ getTitle("cart", "see_cart") }}
                  </a>
                  <a
                    href="#"
                    class="col-4 btn btn-secondary align-self-stretch d-flex align-items-center justify-content-center"
                    @click.prevent="toggleModal"
                  >
                    {{ getTitle("cart", "continue_buying") }}
                  </a>
                </div>
              </div>
            </div>
            <div
              v-else
              :style="{ height: '150px' }"
              class="d-flex justify-content-center align-items-center"
            >
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { CartService } from "~/services/CartService";
import {
  getTitleTranslate,
  getEshopLinkTranslate,
  getTitleTranslateWithOptions,
} from "@/utils/general";
import ImageProduct from "@/components/ui/ImageProduct.vue";
import { formatPrice } from "@/utils/pricing";

const cartService = new CartService();

export default {
  components: {
    ImageProduct,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Array<{ cart: unknown }>,
      default() {
        return [];
      },
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ["updateShow"],
  data: function () {
    return {
      cartService: null as CartService | null,
      modal: null as { hide: () => void; show: () => void } | null,
    };
  },
  computed: {
    idModal() {
      return "modal_cart_add_products_" + Math.random() * 99;
    },
    cart() {
      const index = this.info.length - 1;
      if (
        this.info &&
        this.info.length > 0 &&
        this.info[index] &&
        this.info[index].cart
      ) {
        return this.info[index].cart;
      }
      return null;
    },
    customerLimitWarning() {
      if (!this.info || !this.info.length) return null;
      for (const entry of this.info) {
        const warning = entry?.addedInfo?.customer_limit_warning;
        if (warning) return warning;
      }
      return null;
    },
  },
  watch: {
    show(newShow) {
      if (newShow) {
        cartService.getCartInitData();
        this.modal?.show();
      } else {
        this.modal?.hide();
      }
    },
  },
  mounted() {
    this.initModal();
  },
  methods: {
    async initModal() {
      const { Modal } = await import("bootstrap");
      const modelElem = document.getElementById(this.idModal);
      if (modelElem) {
        this.modal = new Modal("#" + this.idModal);
        modelElem.addEventListener("hide.bs.modal", () => {
          this.$emit("updateShow", false);
        });
        modelElem.addEventListener("show.bs.modal", () => {
          this.$emit("updateShow", true);
        });
      }
    },
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },
    getTitleOptions(section: string, name: string, options: unknown) {
      return getTitleTranslateWithOptions(section, name, options);
    },
    getEshopLink(section: string, name: string) {
      return getEshopLinkTranslate(section, name);
    },
    goToCheckout() {
      this.modal?.hide();
      this.$router.push({
        name: "cart-payment",
        query: { fromAddedToCart: "1" },
      });
    },
    goTo(to: { name: string }) {
      this.modal?.hide();
      this.$router.push(to);
    },
    toggleModal() {
      if (!this.show) {
        this.modal?.show();
      } else {
        this.modal?.hide();
      }
    },
    formatPrice,
  },
};
</script>

<style lang="sass">
.last-no-border:last-child
    border: 0px !important
</style>
